import { createContext } from 'react';

export type LastVisitedRouteContextValue = {
	lastVisitedRoute: string | null;
	resumeLastVisitedRoute: () => void;
};

export const LastVisitedRouteContext = createContext<LastVisitedRouteContextValue | null>(null);
